import { yup } from '@guiker/yup-util'

export const tenantApplicationByUserId = yup
  .object({
    userId: yup.string().required(),
  })
  .required()
